import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import { PixelStatus } from '@/types/pixel';
import { cn } from '@/lib/utils';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';

interface PixelStatusBadgeProps {
  status: PixelStatus;
  className?: string;
}

const statusConfig: Record<PixelStatus, {
  text: string;
  className: string;
  tooltip?: string;
}> = {
  ativo: {
    get text() { return translateInterfaceText("Ativo"); },
    className: "bg-blue-50 text-blue-700 border-blue-200"
  },
  desativado: {
    text: "Desativado",
    className: "bg-gray-50 text-gray-600 border-gray-200"
  },
  sem_eventos: {
    get text() { return translateInterfaceText("Sem Eventos"); },
    className: "bg-gray-50 text-gray-600 border-gray-200",
    get tooltip() { return translateInterfaceText("Nenhum evento detectado ainda. Verifique se o pixel está instalado na página vinculada."); }
  }
};

export function PixelStatusBadge({ status, className }: PixelStatusBadgeProps) {
  useLanguage();
  const config = statusConfig[status];

  const badge = (
    <span
      className={cn(
        "inline-flex items-center px-2.5 py-1.5 rounded-lg text-xs font-medium border cursor-default",
        config.className,
        className
      )}
      role="status"
      aria-label={config.text}
    >
      {config.text}
    </span>
  );

  if (config.tooltip) {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            {badge}
          </TooltipTrigger>
          <TooltipContent className="max-w-[280px]">
            <p>{config.tooltip}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  return badge;
}
